import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

import moment from 'moment-timezone';
import { TimezoneService } from '@services/timezone.service';

@Pipe({
  name: 'userTimezoneDate',
})
export class UserTimezoneDatePipe implements PipeTransform {
  private userTimezone: string;

  constructor(
    @Inject(LOCALE_ID) readonly locale: string,
    private readonly datePipe: DatePipe,
    private readonly timezoneService: TimezoneService,
  ) {
    this.timezoneService.timezone.subscribe((tz) => (this.userTimezone = tz));
  }

  transform(value: string | number | Date, format = 'mediumDate'): string {
    if (value && this.userTimezone) {
      const timezoneFormatted = moment.utc(value).tz(this.userTimezone).format('YYYY-MM-DD HH:mm:ss');
      return this.datePipe.transform(timezoneFormatted, format, '', this.locale);
    }
    return '';
  }
}
